// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';

export const customStyles = css`
  display: flex;
  flex: 1;
  padding-top: 11px;
  padding-bottom: 6px;
  border-top: solid 1px rgba(163, 162, 162, 0.5);
  background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
  img {
    height: 13px;
    width: 13px;
    padding: 4px 7px 0 10px;
  }
  span {
    font-weight: bold;
    font-size: 14px;
  }
  .removeErrorMessage {
    text-decoration: underline;
    cursor: pointer;
    padding-bottom: 6px;
  }
`;

export const bagTileCSS = css`
  display: flex;
  flex: 1;
  padding-top: 11px;
  padding-bottom: 6px;
  background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
  img {
    height: 18px;
    width: 18px;
    padding: 4px 7px 0 10px;
  }
  span {
    font-weight: bold;
    font-size: 16px;
  }
  .removeErrorMessage {
    text-decoration: underline;
    cursor: pointer;
    padding-bottom: 6px;
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    img {
      height: 13px;
      width: 13px;
      padding-left: 0px;
      padding-right: 8px;
    }
    span {
      font-size: 14px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    img {
      padding-left: 0px;
      padding-right: 14px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    img {
      padding-right: 18px;
    }
  }
`;

export const miniBagCSS = css`
  position: relative;
`;

export const productTileCss = css`
  margin: 15px 0;
  background: ${(props) => (!props.isBagPageSflSection ? '#fff;' : 'none')};
  padding-top: ${(props) => (!props.isBagPageSflSection ? '10px;' : '0')};
  padding-left: ${(props) => (!props.isBagPageSflSection ? '15px;' : '0')};
  padding-right: ${(props) => (!props.isBagPageSflSection ? '15px;' : '0')};
  padding-bottom: ${(props) => (!props.isBagPageSflSection ? '20px;' : '0')};
  position: relative;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding-bottom: ${(props) => (!props.isBagPageSflSection ? '12px;' : '0')};
    padding-right: ${(props) => (!props.isBagPageSflSection ? '12px;' : '0')};
    padding-left: ${(props) => (!props.isBagPageSflSection ? '4px;' : '0')};
    padding-top: ${(props) => (!props.isBagPageSflSection ? '21px;' : '0')};
    margin: 16px 0px 0px;
  }
`;

const styles = css`
  .group-wrapper {
    padding: ${(props) =>
      props.isDesktopProductTileCleanUpDisabled ? props.theme.spacing.ELEM_SPACING.LRCX : '24px'};
    ${(props) => !props.isDesktopProductTileCleanUpDisabled && `padding-bottom: 0px`};
    background: ${(props) => props.theme.colorPalette.white};
    margin: ${(props) =>
        props.isShowBagSimplifiedHeader ? '20px 0 16px' : props.theme.spacing.ELEM_SPACING.MED}
      0;
    border-radius: ${(props) =>
      props.isMobileWebTileEnhancementEnabled ? '0px' : props.theme.spacing.ELEM_SPACING.XS_1};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) =>
        props.isMobileWebTileEnhancementEnabled
          ? '0px 16px 24px;'
          : props.theme.spacing.ELEM_SPACING.XS};
      ${(props) => !props.isMobileWebTileEnhancementEnabled && `padding-bottom: 12px;`}
    }
  }
  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isMobileWebProductTile &&
        !props.isMobileWebTileEnhancementEnabled &&
        `margin-bottom: 16px;`};
    }
  }
  .main-products-container {
    ${(props) => !props.isDesktopProductTileCleanUpDisabled && `margin-bottom: 15px;`}
  }
  .bagPageSection {
    padding: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) => !props.isDesktopProductTileCleanUpDisabled && `margin: 0px;`};
      ${(props) =>
        !props.isDesktopProductTileCleanUpDisabled &&
        `:last-child {
            .transitions-style {
              border: none;
            }
          }
          `};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => props.isMobileWebProductTile && `margin: 0px;`}
    }
    ${(props) =>
      props.isMobileWebProductTile &&
      `:last-child, :nth-last-child(2) {
        .transitions-style {
          border: none;
        }
      }
    `};
  }

  .section {
    display: flex;
    flex-direction: row;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 20px;
    }
  }
  .total-items {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 4px;
    }
  }
  .store-details-container-new-design {
    border: 1px solid
      ${(props) =>
        !props.isDesktopProductTileCleanUpDisabled
          ? props.theme.colorPalette.orange[800]
          : props.theme.colorPalette.gray[500]};
    ${(props) =>
      !props.isDesktopProductTileCleanUpDisabled &&
      `border-left: 6px solid ${props.theme.colorPalette.orange[800]};`}
    border-radius: ${(props) =>
      props.isDesktopProductTileCleanUpDisabled ? props.theme.spacing.ELEM_SPACING.XS_6 : '10px'};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    background: ${(props) => props.theme.colorPalette.white};
  }
  .store-details-container {
    background-color: #f4f4f4;
    border-radius: ${(props) =>
      props.isDesktopProductTileCleanUpDisabled ? props.theme.spacing.ELEM_SPACING.XS_6 : '10px'};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  ${(props) =>
    !props.isDesktopProductTileCleanUpDisabled &&
    `.change-store-link {
    color: ${props.theme.colorPalette.blue[1300]};
    font-weight: bold;
    font-size: 14px;
  }
  .capFirstLetter::before {
    background-image: none;
  }
  .capFirstLetter{
    padding-left: 0px;
  }`}
  ${(props) =>
    props.theme.isPJP
      ? `
  .store-icon {
    padding-left: 40px;
    position: relative;
  }
  .store-icon::before {
    background-image: url(https://assets.theplace.com/image/upload/ecom/assets/static/icon/no-rush.svg);
    background-repeat: no-repeat;
    content: "";
    background-size: auto;
    position: absolute;
    top: -7px;
    left: 0;
    width: 100%;
    height: 32px
  }`
      : ''};
  .mini-group-wrapper {
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    background: ${(props) => props.theme.colorPalette.white};
    margin: 4px 12px 10px 12px;
    border-radius: 10px;
  }
  .mini-icon {
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  }
  .mini-container-pt {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .mini-item-count {
    margin-left: auto;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .mini-section {
    width: 100%;
  }
  .mini-bag {
    .accessories-tile-wrapper {
      margin-left: 11%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .rgt-content {
      width: 100%;
      justify-content: space-between;
    }
    .lft-content {
      width: 100%;
    }
    .shipping-methods-container {
      width: 100%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .rgt-content {
      padding-top: 16px;
      padding-right: 12px;
      padding-left: 8px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    }
  }

  .view-all-sfl-btn {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    color: #1a1a1a;
  }
  ${(props) =>
    !props.isMobileWebProductTile &&
    `.transitions {
    border: 2px solid ${props.theme.colorPalette.gray[300]};
  }`}
  ${(props) =>
    props.isMobileWebProductTile &&
    `.shipping-text {
    @media ${props.theme.mediaQuery.smallOnly} {
      letter-spacing: 1px;
      font-size: ${props.theme.typography.fontSizes.fs16};
      font-weight: ${props.theme.typography.fontWeights.extrabold};
    }
  }`}
`;

const getViewAllShowLessStyles = (props) => {
  return `
  font-family: ${props.theme.fonts.secondaryFontFamily};
  font-weight: ${
    props.isDesktopProductTileCleanUpDisabled
      ? props.theme.typography.fontWeights.extrabold
      : props.theme.typography.fontWeights.bold
  };
  font-size: ${
    props.isDesktopProductTileCleanUpDisabled
      ? props.theme.typography.fontSizes.fs12
      : props.theme.typography.fontSizes.fs16
  };
  color: #1a1a1a;`;
};

export const ViewAll = styled(Button)`
  ${(props) => getViewAllShowLessStyles(props)}
`;

export const ShowLessText = styled(Anchor)`
  ${(props) => getViewAllShowLessStyles(props)}
`;

export default styles;
